module.exports = __webpack_public_path__ + "img/avatar3.18a94cfa.png";